const maxLength = max => value =>
  value && value.length > max ? `Moet ${max} tekens of minder zijn` : undefined;

const minLength = (min, text) => value =>
  value && value.length < min ? text : undefined;

export const number = value => value && isNaN(Number(value)) ? 'Moet een nummer zijn' : undefined;

export const positive = value => value && value < 0 ? 'Waarde moet groter zijn dan nul' : undefined;

export const required = value => value ? undefined : 'Verplicht';

export const checked = value => value ? undefined : 'Aanvinken om door te kunnen gaan';

export const maxLength25 = maxLength(25);

export const minLength2 = minLength(2, 'Moet minimaal 2 tekens bevatten');

export const passwordMinLength = minLength(6, 'Wachtwoord moet 6 karakters lang zijn. Wachtwoord moet cijfers en letters bevatten.');

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Ongeldig email adres'
    : undefined;

export const username = value => 
  value && !/^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9_-]+)?$/i.test(value)
    ? 'Gebruikersnaam moet letters bevatten en kan cijfers en bevatten _ - characters'
    : undefined;

export const alphanumeric = value => 
  value && !/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/.test(value)
    ? 'Wachtwoord moet letters en cijfers bevatten'
    : undefined;

export const compare_password = (value, allValues) => 
  value !== allValues.password ? 'Wachtwoord komt niet overeen' : undefined;

export const compare_email = (value, allValues) => 
  value !== allValues.email ? 'E-mails komen niet overeen' : undefined;
